// src/modules/app-views/_apps/appmulti/plans/pages/Init/components/tableColumns/priceColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag } from 'antd';
import translateX from 'utils/translateX';
import plansService from 'modules/app-views/_apps/appmulti/plans/service';
import financialService from 'services/financialService';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function priceColumn(buildColumnProps, options = {}) {
  const {
    key = 'price',
    title = 'price',
    dataIndex = 'price',
    width = 120,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    align: 'right',
    render: (_, r) => {
      const price = r?.price;
      const priceType = r?.priceType;
      const currency = r?.currency;
      const symbol = plansService.getCurrencySymbol(currency);

      if (priceType === 'table') {
        return <Tag>{translateX('table')}</Tag>;
      }

      if (!price && price !== 0) return <span className="text-muted">—</span>;

      const formattedPrice = financialService.formatNumber(price, {
        decimals: 2,
        locale: 'pt-BR',
      });

      const typeLabel = priceType === 'daily' ? `/${translateX('day')}` : '';

      return (
        <span className="font-weight-semibold">
          {symbol} {formattedPrice}
          {typeLabel}
        </span>
      );
    },
  };
}

export default priceColumn;
